import React from "react";
import { stackList2 } from "../../data/ProjectData";
import {
  Image,
  Technologies,
  Tech,
  TechImg,
  TechName,
  ContactWrapper,
} from "./AboutElements";
import ScrollAnimation from "react-animate-on-scroll";
function About() {
  return (
    <>
      <svg
        // height="100%"
        width="100%"
        id="svg"
        viewBox="0 0 1440 400"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M 0,400 C 0,400 0,200 0,200 C 114.35714285714289,156.53571428571428 228.71428571428578,113.07142857142858 351,131 C 473.2857142857142,148.92857142857142 603.4999999999998,228.25 713,248 C 822.5000000000002,267.75 911.2857142857144,227.92857142857142 1029,210 C 1146.7142857142856,192.07142857142858 1293.3571428571427,196.03571428571428 1440,200 C 1440,200 1440,400 1440,400 Z"
          stroke="none"
          strokeWidth="0"
          fill="#151418ff"
          transform="rotate(-180 720 200)"
        ></path>
      </svg>
      <ContactWrapper id="about">
        <div className="Container">
          <div className="SectionTitle">About Me</div>
          <div className="BigCard">
            <ScrollAnimation animateIn="fadeInTop">
              <Image src="/my-photo.png" alt="my-photo" />
            </ScrollAnimation>
            <div className="AboutBio">
              <ScrollAnimation animateIn="fadeInLeft">
                Hello! My name is <strong>Nikunj Nadiyapara</strong>. I’m from
                Rajkot, Gujarat, India. I am a passionate and dedicated web
                developer. I completed my Diploma in Computer Engineering. Over
                the years, I’ve built my skills by working on real projects and
                learning from hands-on experience.
              </ScrollAnimation>

              <br />

              <ScrollAnimation animateIn="fadeInLeft">
                I specialize in creating responsive and user-friendly web
                applications using modern technologies like HTML, CSS,
                JavaScript, React.js, and Next.js. I enjoy solving problems
                through code and always try to write clean and maintainable
                code. I’ve also worked with tools like Git and GitHub for
                version control and love working in teams where I can learn and
                grow with others.
              </ScrollAnimation>

              <br />

              <ScrollAnimation animateIn="fadeInLeft">
                In addition to web development, I have experience in backend
                technologies like Node.js, ExpressJS, and PHP, as well as
                working with databases such as MongoDB, MySQL and Firebase. I’ve
                also explored real-time communication using Socket.IO.
              </ScrollAnimation>

              <br />

              <ScrollAnimation animateIn="fadeInLeft">
                I'm comfortable using tools and platforms like AWS, Firebase,
                Vercel, Render, WordPress, and Postman. I also use design and
                planning tools like Figma and VS Code in my development
                workflow. I believe learning never stops, and I’m always open to
                exploring new technologies and improving my skills.
              </ScrollAnimation>

              <br />
              <br />

              <>
                <TechCategorySection
                  title="Programming Languages"
                  techList={stackList2.programmingLanguages}
                />
                <TechCategorySection
                  title="Frameworks / Libraries"
                  techList={stackList2.frameworks}
                />
                <TechCategorySection
                  title="Databases"
                  techList={stackList2.databases}
                />
                <TechCategorySection
                  title="Payment Gateways"
                  techList={stackList2.paymentGateways}
                />
                <TechCategorySection
                  title="Tools / Platforms / DevOps"
                  techList={stackList2.tools}
                />
              </>
              {/* <Technologies>
              {stackList.map((stack, index) => (
                <ScrollAnimation animateIn="fadeInLeft" key={index}>
                  <Tech key={index} className="tech">
                    <TechImg src={stack.img} alt={stack.name} />
                    <TechName>{stack.name}</TechName>
                  </Tech>
                </ScrollAnimation>
              ))}
            </Technologies> */}
            </div>
          </div>
        </div>
      </ContactWrapper>
    </>
  );
}

export default About;

const TechCategorySection = ({ title, techList }) => {
  return (
    <ScrollAnimation animateIn="fadeIn">
      <>
        <strong>
          <span style={{ fontSize: "1.2rem" }}>{title}</span>
        </strong>
        <br />
        <br />
        <Technologies>
          {techList.map((stack, index) => (
            <ScrollAnimation animateIn="fadeIn" key={index}>
              <Tech key={index} className="tech">
                <TechImg src={stack.img} alt={stack.name} />
                <TechName>{stack.name}</TechName>
              </Tech>
            </ScrollAnimation>
          ))}
        </Technologies>
        <br />
      </>
    </ScrollAnimation>
  );
};
